import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LoadingPage } from "./LoadingSpinner";
import { useAuth } from "../contexts/AuthContext";
import i18n from "../i18n/config";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingPage message={i18n.t("common.checkingAccess")} />;
  }

  if (!isAuthenticated) {
    // Redirect to login page with return URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
